import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'
import Y from '../../../y18n'
import * as subscriptionActions from '../../../store/subscriptions'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  subscriptions: state.subscriptions
})

const mapDispatchToProps = dispatch => ({
  subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
})

class NewSubscriptionDialog extends Component {
  state = {
    clicked: false
  }

  inputChanged = name => e => {
    this.props.subscriptionActions.updateActive(name, e.target.value)
  }

  submitForm (e, id, name) {
    e.preventDefault()
    this.setState({ clicked: true })
    this.props.subscriptionActions.createSubscription(this.props.subscriptions.active).then(res => {
      if (!this.props.subscriptions.dialogLoading) {
        this.props.handleReload()
        this.setState({ clicked: false })
      }
    })
  }

  render () {
    const { subscriptions, subscriptionActions, classes } = this.props
    if (!subscriptions.active || !subscriptions.new) return null
    return (
      <Dialog
        open={subscriptions.active !== null}
        onClose={() => subscriptionActions.resetNew()}
        aria-labelledby='new-subscription-dialog'
        classes={{
          paper: classes.dialogContent
        }}
      >
        {subscriptions.dialogLoading && <LinearProgress />}
        <form onSubmit={e => this.submitForm(e, subscriptions.active.id, subscriptions.active.name)}>
          <DialogTitle id='new-subscription-dialog'>{Y`Add subscription`}</DialogTitle>
          <DialogContent>
            <TextField
              margin='normal'
              label={Y`Name`}
              type='text'
              value={subscriptions.active.name || ''}
              onChange={this.inputChanged('name')}
              helperText={Y`Give your subscription a name to make it easier to recognize it`}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              required
              fullWidth
            />
            <TextField
              margin='normal'
              label={Y`IMSI`}
              type='text'
              value={subscriptions.active.imsi || ''}
              onChange={this.inputChanged('imsi')}
              helperText={Y`You find your IMSI number on the back of the folder which your SIM-card was delivered in`}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel,
                error: subscriptions.active.imsi && subscriptions.active.imsi.length > 15
              }}
              required
              fullWidth
            />
            <TextField
              margin='normal'
              label={Y`Verification code`}
              type='text'
              value={subscriptions.active.verificationCode || ''}
              onChange={this.inputChanged('verificationCode')}
              helperText={Y`You find your verification code on the back of the folder which your SIM-card was delivered in`}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              required
              fullWidth
            />
            {subscriptions.error &&
              <Typography variant='body2' style={{ color: 'red', marginTop: '20px' }}>
                {Y`${subscriptions.error}`}
              </Typography>}
            {subscriptions.active.imsi &&
              subscriptions.active.imsi.length > 15 &&
              <Typography variant='body2' style={{ color: 'red', marginTop: '20px' }}>
                {Y`The IMSI needs to be 15 digits long. Please check that it matches the IMSI number found on the back of the folder which your SIM-card was delivered with`}
              </Typography>}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => subscriptionActions.resetNew()} style={{ marginRight: '20px' }}>{Y`Close`}</Button>
            <Button
              type='submit'
              variant='raised'
              color='primary'
              style={{ color: '#fff' }}
              disabled={this.state.clicked}
            >
              {Y`Add subscription`}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

NewSubscriptionDialog = connect(mapStateToProps, mapDispatchToProps)(NewSubscriptionDialog)
export default withStyles(Styles)(NewSubscriptionDialog)



// WEBPACK FOOTER //
// ./src/pages/subscriptions/containers/new-subscription-dialog.js